"use client";

import type { AnalyticsBrowser } from "@segment/analytics-next";
import type { Dispatch, SetStateAction } from "react";
import { createContext } from "react";

import type { AnalyticsEvent } from "../types";

export type AnalyticsContext = {
  analytics: AnalyticsBrowser;
  consent: number[];
  logout: Function;
  setConsent: Dispatch<SetStateAction<number[]>>;
  track: (props: AnalyticsEvent) => Promise<void>;

  /** TODO: remove/improve when ConsentModal/CookieManager are improved */
  isConsentModalVisible: boolean;
  saveConsent: (props: Pick<AnalyticsContext, "consent">) => Promise<void>;
  setIsConsentModalVisible: Dispatch<SetStateAction<boolean>>;
};

export const analyticsContext = createContext<AnalyticsContext>({
  analytics: null,
  consent: [],
  logout: () => {},
  setConsent: () => {},
  track: () => Promise.resolve(),

  /** TODO: remove/improve when ConsentModal/CookieManager are improved */
  isConsentModalVisible: false,
  saveConsent: () => Promise.resolve(),
  setIsConsentModalVisible: () => {},
});
